<template lang="pug">
div
    RoleSelect(v-if="loaded")
    div(v-if="allowedRoles.includes(login_user.role)")
        h1 Import Fee
        b-card.border-0
            b-form(@submit.prevent="importFee")
                b-form-group(label="Fee Year:")
                    b-form-select(v-model="feeYear" required)
                        <b-form-select-option :value="2020">2020</b-form-select-option>
                        <b-form-select-option :value="2021">2021</b-form-select-option>
                        <b-form-select-option :value="2022">2022</b-form-select-option>
                b-form-group(label="Fee File:")
                    b-form-file(@change="processFeeFile" accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" required)
                b-form-group
                    b-button(type="submit" :disabled="(isSubmitting) || (!feeJson)") {{ isSubmitting ? 'Importing...' : 'Import'}}

                b-spinner.mr-2(v-if="isSubmitting" small variant="secondary" label="Spinning")
                span(v-if="isSubmitting") Importing {{currentRow}} of {{totalRow}} data
                
                div(v-for="errMsg in errorLog")
                    div.text-danger
                        b-icon.mr-1(icon="exclamation-triangle")
                        | {{errMsg}}
    div(v-else)
        p.my-4 You're not allowed to view this page as {{login_user.role.replace(/_/g, ' ')}}
</template>

<script>
import dayjs from 'dayjs';
import RoleSelect from '@/components/roleSelect.vue';
import XLSX from 'xlsx';

export default {
    components: {
        RoleSelect,
    },
    computed: {
        loaded(){
            return this.$store.state.loaded;
        },
        login_user(){
            return this.$store.state.login_user;
        },
    },
    data(){
        return{
            allowedRoles:['admin'],
            isSubmitting: false,
            feeYear: null,
            profileJson: null,
            feeJson: null,
            shelterId: null,
            admissionType: null,
            totalRow: 0,
            currentRow: 0,
            errorLog: []
        }
    },
    methods: {
        dayjs,
        processProfileFile(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return false;

            let file = files[0];

            var reader = new FileReader();
            reader.readAsArrayBuffer(file);

            let vm = this;

            reader.onload = function(e) {
                var data = new Uint8Array(e.target.result);
                var workbook = XLSX.read(data, {type: 'array'});
                let sheetName = workbook.SheetNames[1];
                let worksheet = workbook.Sheets[sheetName];

                vm.profileJson = XLSX.utils.sheet_to_json(worksheet, {range:1});
            };
        },
        processFeeFile(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return false;

            let file = files[0];

            var reader = new FileReader();
            reader.readAsArrayBuffer(file);

            let vm = this;

            reader.onload = function(e) {
                var data = new Uint8Array(e.target.result);
                var workbook = XLSX.read(data, {type: 'array'});
                //let sheetName = workbook.SheetNames[1];
                let worksheet = workbook.Sheets["Shelter_Utility fee recording"];

                console.log(workbook);

                vm.feeJson = XLSX.utils.sheet_to_json(worksheet, {range:0});
            };
        },
        /**
         * Levenshtein distance algorithm returns the percentage of match between two strings
         * @param {string} s1 - The 1st string you want to compare.
         * @param {string} s2 - The 2nd string you want to compare.
         * @returns {number} Returns a value between 0 to 1 that represent percentage of match.
         */
        similarity(s1, s2) {
            if(s1 === null || s2 === null) {
                return 0;
            }

            var longer = s1;
            var shorter = s2;
            if (s1.length < s2.length) {
                longer = s2;
                shorter = s1;
            }
            var longerLength = longer.length;
            if (longerLength == 0) {
                return 1.0;
            }
            return (longerLength - this.editDistance(longer, shorter)) / parseFloat(longerLength);
        },
        editDistance(s1, s2) {
            s1 = s1.toLowerCase();
            s2 = s2.toLowerCase();

            var costs = new Array();
            for (var i = 0; i <= s1.length; i++) {
                var lastValue = i;
                for (var j = 0; j <= s2.length; j++) {
                if (i == 0)
                    costs[j] = j;
                else {
                    if (j > 0) {
                    var newValue = costs[j - 1];
                    if (s1.charAt(i - 1) != s2.charAt(j - 1))
                        newValue = Math.min(Math.min(newValue, lastValue),
                        costs[j]) + 1;
                    costs[j - 1] = lastValue;
                    lastValue = newValue;
                    }
                }
                }
                if (i > 0)
                costs[s2.length] = lastValue;
            }
            return costs[s2.length];
        },
        async getUserIdByEmail(email) {
            if(!email) {return false;}

            return await this.$store.dispatch('getUserByEmail', email).then((result)=>{
                return result?.graph_id || false;
            }).catch(()=>{
                return false;
            })
        },
        async getCaseByRefId(refId) {
            if(!refId) {return false;}

            return await this.$store.dispatch('getCaseByRefId', refId).then((result)=>{
                if(result.value.length > 0)
                    return result.value[0];
                else
                    return false;
            }).catch(()=>{
                return false;
            })
        },
        async setCaseManager(caseId, caseManagerId) {
            if(!caseId && !caseManagerId) {return false;}

            return await this.$store.dispatch('editCase', { caseId:caseId, payload:{new_casemanager:caseManagerId} }).then((result)=>{
                return result;
            }).catch(()=>{
                return false;
            })
        },
        /**
         * Add shelter fee milestone to case
         * @param {string} caseId - Id of case where you want to add fee milestone.
         * @param {object} data - The raw data from excel (converted to json).
         */
        async addFeeMilestone(caseId, data) {
            console.log(caseId,data);
            if(!caseId || !data) { return false; }

            // get operations caseplan where category=shelterfee
            let feeCasePlanId = null;
            let feeMilestoneOrder = 0;
            console.log(feeCasePlanId);
            await this.$store.dispatch('fetchCasePlan', {caseId:caseId, category:'operations'}).then((result)=>{
                console.log(result);

                // find existing fee caseplan if any
                for(let casePlan of result) {
                    if(casePlan.new_category == 100000007) {
                        feeCasePlanId = casePlan.new_caseplanid;
                        feeMilestoneOrder = casePlan?.new_Milestone_CasePlan.length || 0; // get shelterfee milestone order
                    }
                }
            });

            // Prepare payload
            let milestoneName = "Fee";
            let feeType = data?.["Type of Fee (Shelter Fee or Utilities)"] || null;
            let isShelterFee = true;
            // if type=shelter fee or is null
            if(!feeType || feeType.toLowerCase().trim() === "shelter fee") {
                milestoneName = "Shelter Fee";
                isShelterFee = true;
            }
            else {
                milestoneName = feeType ? feeType : "Other Fee";
                isShelterFee = false;
            }

            let milestoneJson = [];
            for(let i=1; i<=12; i++) {
                let monthString = i.toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false});

                if( !this.currencyToFloat(data?.[`${monthString} Fee`]) ) { continue; }

                let paymentStatusId = null;
                //check payment status
                if(this.currencyToFloat(data?.[`${monthString} Paid / Waived`]) < this.currencyToFloat(data?.[`${monthString} Fee`])) {
                    paymentStatusId = '100000002'; //partial
                }
                if(this.currencyToFloat(data?.[`${monthString} Paid / Waived`]) >= this.currencyToFloat(data?.[`${monthString} Fee`]) || (data?.[`${monthString} Paid / Waived`] || '').toLowerCase().trim() === 'paid' || (data?.[`${monthString} Paid / Waived`] || '').toLowerCase().trim() === 'waived') {
                    paymentStatusId = '100000000'; //fully paid
                }
                if((data?.[`${monthString} Paid / Waived`] || '').toLowerCase().trim() === 'unpaid' || (this.currencyToFloat(data?.[`${monthString} Paid / Waived`]) === null && !((data?.[`${monthString} Paid / Waived`] || '').toLowerCase().trim() === 'paid' || (data?.[`${monthString} Paid / Waived`] || '').toLowerCase().trim() === 'waived'))) {
                    paymentStatusId = '100000001'; //unpaid
                }

                let feeJson = {
                    new_order: feeMilestoneOrder += 1,
                    new_name: `${milestoneName} (${i}/${this.feeYear})`,
                    new_status: '100000000',
                    new_type: '100000011',
                    new_requiredattachments: '["Shelter Fee Receipt"]',
                    new_date: new Date().toISOString(),
                    new_opsfeetype: isShelterFee ? '100000001' : '100000000',
                    new_opsfeetypeothers: isShelterFee ? '' : milestoneName,
                    new_opsfeeamount: this.currencyToFloat(data?.[`${monthString} Fee`]),
                    new_opsfeedatesent: `${this.feeYear}-${monthString}-01`,
                    //new_opsfeedatedue: null,
                    new_opsfeestatus: paymentStatusId, //unpaid100000001, partial100000002, fully100000000 (based of sum of payment)
                    //new_opsfeeactionneeded: '', //transaction not tally
                    new_notes: data?.[`${monthString} Comment`] || '',
                    new_opsfeesheltermonth: i,
                    new_opsfeeshelteryear: this.feeYear,
                    new_Transaction_Milestone: []
                }

                // if paid column exist & not unpaid & is a number
                if(!paymentStatusId || paymentStatusId !== '100000001') {
                    feeJson.new_Transaction_Milestone = [{
                        new_amount: typeof this.currencyToFloat(data?.[`${monthString} Paid / Waived`]) == 'number' ? this.currencyToFloat(data?.[`${monthString} Paid / Waived`]) : this.currencyToFloat(data?.[`${monthString} Fee`]),
                        new_type: (data?.[`${monthString} Fee`] || '').toLowerCase().trim() === 'waived' || (data?.[`${monthString} Paid / Waived`] || '').toLowerCase().trim() === 'waived'  ? '100000001' : '100000000',
                        new_receiptdate: dayjs(data?.[`${monthString} Receipt Date (YYYY-MM-DD)`], 'YYYY-MM-DD').isValid() ? data?.[`${monthString} Receipt Date (YYYY-MM-DD)`] : null,
                        //new_remark: transaction.new_remark,
                        //new_cmapproval: transaction.new_cmapproval,
                    }];
                }
                /*
                if(data?.[`${monthString} Paid / Waived`] && (data?.[`${monthString} Paid / Waived`] || '').toLowerCase().trim() !== 'unpaid' && typeof this.currencyToFloat(data?.[`${monthString} Paid / Waived`]) == 'number') {
                    feeJson.new_Transaction_Milestone = [{
                        new_amount: typeof this.currencyToFloat(data?.[`${monthString} Paid / Waived`]) == 'number' ? this.currencyToFloat(data?.[`${monthString} Paid / Waived`]) : this.currencyToFloat(data?.[`${monthString} Fee`]),
                        new_type: (data?.[`${monthString} Fee`] || '').toLowerCase().trim() === 'waived' ? '100000001' : '100000000',
                        new_receiptdate: dayjs(data?.[`${monthString} Receipt Date (YYYY-MM-DD)`], 'YYYY-MM-DD').isValid() ? data?.[`${monthString} Receipt Date (YYYY-MM-DD)`] : null,
                        //new_remark: transaction.new_remark,
                        //new_cmapproval: transaction.new_cmapproval,
                    }];
                }*/

                milestoneJson.push(feeJson);
            }

            console.log(milestoneJson);

            
            // if fee caseplan not exist create new fee caseplan, including milestone
            if(!feeCasePlanId) {
                let feeCasePlanJson = {
                    new_name: 'Fee Milestone',
                    new_category: '100000007',
                    new_Milestone_CasePlan: milestoneJson
                }

                // exit the current function here and skip the next line
                return await this.$store.dispatch('addCasePlan',{caseId:caseId, payload:feeCasePlanJson}).then(()=>{
                    //feeCasePlanId = result.new_caseplanid;
                    return true;
                }).catch((err)=>{
                    this.errorLog.push(err);
                    return false;
                });
            }

            // POST fee milestone
            for(let payload of milestoneJson) {
                // no await, run in parallel
                this.$store.dispatch('addMilestone',{casePlanId:feeCasePlanId, payload:payload}).catch((err)=>{
                    this.errorLog.push(err);
                });
            }
            
        },
        // Take string currency and convert to float
        currencyToFloat(currency) {
            if(!currency) {return null;}
            currency = currency.trim().replace( /^\D+/g, '');
            return parseFloat(currency) ? parseFloat(currency) : null;
        },
        async importFee() {
            this.isSubmitting = true;
            this.errorLog = [];
            this.currentRow = 0;
            this.totalRow = 0;

            console.log(this.feeJson);

            // check if both of this json exist
            if(!this.feeJson) {
                return false;
            }

            this.totalRow = this.feeJson.length;
        
            for(let fee of this.feeJson) {
                this.currentRow += 1;

                // GET case obj where refId match the result from profileJson
                let caseObj = await this.getCaseByRefId((fee?.["File Ref"]) ? fee["File Ref"].trim() : null);
                // If none match add to error log message and stop proceeding to next line (continue)
                if(!caseObj) {
                    this.errorLog.push(`No matching case found in the database for the reference id ${fee?.["File Ref"]}`);
                    continue;
                }

                // POST new fee milestone obj based on feeJson raw data
                await this.addFeeMilestone(caseObj?.new_caseid, fee);

                /*** Get case manager from feeJson and match with a user in certainty db ***/
                // GET user where email = case manager email
                if(!fee?.["Case Manager"]){ // if none, skip iteration
                    this.errorLog.push(`Missing case manager for ${fee?.["Name"]} in Fee File`)
                    continue;
                }

                let caseManagerId = await this.getUserIdByEmail(`nhcs-${fee?.["Case Manager"]}`);
                if(!caseManagerId) {
                    this.errorLog.push(`Case manager nhcs-${fee?.["Case Manager"]} for ${fee?.["Name"]} not found in the database`)
                    continue;
                }

                console.log(`nhcs-${fee?.["Case Manager"]} = ${caseManagerId}`);

                // PATCH case obj with new case manager
                await this.setCaseManager(caseObj?.new_caseid, caseManagerId);
            }

            console.log(this.errorLog);

            

            this.isSubmitting = false;
        }
        
    }
}
</script>

<style>

</style>